import React from 'react';
import { WysiwygField, CoreLink } from '../../../../components';
import './style.scss';

const NodeKPQuestionPageTeaser = ({ entity, className }) => {
  const title = entity.getIn(['field_content_title', 0, 'value']);

  // Url for node.
  const pageUrl = entity.getIn(['paths', 'nl'], '');
  const answerId = pageUrl.substring(1);

  return (
    <CoreLink className="NodeKPQuestionPageTeaser__link" id={`card-${answerId}`} to={pageUrl}>
      <div className="NodeKPQuestionPageTeaser">
        <div className="NodeKPQuestionPageTeaser__icon">
          <i className="icon icon-arrow-right icon-variant-2" />
        </div>
        <WysiwygField
          className="NodeKPQuestionPageTeaser__heading"
          html={title}
        />
      </div>
    </CoreLink>
  );

};

export default NodeKPQuestionPageTeaser;
